import {
  RECRUITMENT_TYPE_KEYS,
  RECRUITMENT_TYPE_LABELS,
} from '../../../../core/entities/recruitment/constants';
import type {
  RecommendedRecruitment,
  Recruitment,
  SimilarRecruitment,
} from '../../../../core/entities/recruitment/schema';

const convertRecruitment = (
  recruitment: RecommendedRecruitment | SimilarRecruitment,
): Recruitment => {
  const company = recruitment.company
    ? [
        {
          id: recruitment.company.id,
          name: recruitment.company.name,
          industryCategoryID: recruitment.company.industry?.id ?? 0,
          industry: recruitment.company.industry?.name ?? '',
          foundedYear: 0,
          employeeCount: 0,
          followerCount: 0,
          isFollowed: false,
          isWishedIndustry: false,
          isWishedJobType: false,
          isNew: false,
          catchPhrase: '',
          capitalDescription: '',
          pageType: recruitment.can_entry ? 'medium' : '',
          backgroundImageURLs: {
            '300x126': '',
            '640x268': '',
            '948x392': '',
          },
          logoURLs: {
            '140x105': recruitment.company.logo_url ?? '',
            '200x150': recruitment.company.logo_url ?? '',
            '400x300': recruitment.company.logo_url ?? '',
          },
          studyUrl: '',
        },
      ]
    : [];

  // detail_page_urlからidを取得
  // 例: https://example.com/recruiting_info/view/12345 -> 12345
  const id = recruitment.detail_page_url?.split('/').slice(-1)[0];
  // recruiting_item_typeがRECRUITMENT_TYPE_KEYSの値に含まれているかチェック
  const typeKey = Object.values(RECRUITMENT_TYPE_KEYS).includes(
    recruitment.recruiting_item_type as string,
  )
    ? (Object.keys(RECRUITMENT_TYPE_KEYS).find(
        (key) =>
          RECRUITMENT_TYPE_KEYS[key as keyof typeof RECRUITMENT_TYPE_KEYS] ===
          recruitment.recruiting_item_type,
      ) as keyof typeof RECRUITMENT_TYPE_LABELS)
    : 'ETC';

  // labelはkeyに対応するlabelを取得
  const typeLabel =
    RECRUITMENT_TYPE_LABELS[typeKey] ?? RECRUITMENT_TYPE_LABELS.ETC;

  return {
    id: recruitment.id,
    detailID: Number(id) || 0,
    title: recruitment.title,
    category: recruitment.type,
    type: {
      key: recruitment.recruiting_item_type,
      label: typeLabel,
    },
    targetYear: 0,
    publishedAt: '',
    postedAt: '',
    displayEndAt: '',
    schedules: [],
    scheduleWarning: {context: ''},
    tags: [],
    groupedJobTypes: recruitment.job_types ?? [],
    companies: company,
    _inactiveSchedules: [],
    entryURL: recruitment.entry_url,
    detailPageURL: recruitment.detail_page_url,
  };
};

export const convertRecruitments = (
  recruitments: Array<RecommendedRecruitment | SimilarRecruitment>,
): Recruitment[] => {
  return recruitments.map(convertRecruitment);
};
